const HANDLED_FLAG = '__handledByErrorToast';

/**
 * Prevents duplicate error toasts when the same (re-thrown) error is handled on several levels -
 * for example an inner FormComponent (RoutingFormDialog through useErrorHandler)
 * AND the enclosing CrudPage (through useApiErrorHandler). The two toast pipelines share
 * no central dedup, so we mark the error object itself.
 *
 * Returns `true` when the error has already been shown as a toast by another handler
 * (the caller must then NOT show another toast). Otherwise the error is marked as
 * handled and `false` is returned.
 */
export function alreadyShownAsToast(error: unknown): boolean {
  if (!error || typeof error !== 'object') return false;
  if ((error as Record<string, unknown>)[HANDLED_FLAG]) return true;
  try {
    (error as Record<string, unknown>)[HANDLED_FLAG] = true;
  } catch {
    /* frozen error object: then there is no dedup, but also no crash */
  }
  return false;
}
